import { Box } from "@mui/system";

import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalContent from "@/common/components/Modals/AppModalContent";
import AppModalTitle from "@/common/components/Modals/AppModalTitle";

import GeneralBillToInfoOfEntityUpdate, {
  GeneralBillToInfoOfEntityUpdateProps,
} from "./GeneralBillToInfoOfEntityUpdate";

type Props<TResult> = {
  updateProps: GeneralBillToInfoOfEntityUpdateProps<TResult>;
} & Omit<AppModalProps, "children">;

export function GeneralBillToInfoOfEntityUpdateModal<TResult>({
  updateProps,
  ...dialogProps
}: Props<TResult>) {
  return (
    <AppModal fullWidth maxWidth='lg' {...dialogProps}>
      {({ close }) => (
        <>
          <AppModalTitle onClose={close}>Update bill to info</AppModalTitle>
          <AppModalContent>
            <Box sx={{ py: 1 }}>
              <GeneralBillToInfoOfEntityUpdate
                {...updateProps}
                onSave={(newValue) => {
                  updateProps.onSave(newValue);
                  close();
                }}
              />
            </Box>
          </AppModalContent>
        </>
      )}
    </AppModal>
  );
}
